import { useEffect, useRef, useState } from "react";

function useThrottleWithInterval<T>(value: T, interval = 500): T {
  const [throttledValue, setThrottledValue] = useState<T>(value);
  const lastExecuted = useRef<number>(Date.now());

  useEffect(() => {
    if (Date.now() >= lastExecuted.current + interval) {
      lastExecuted.current = Date.now();
      setThrottledValue(value);
    } else {
      const timerId = setTimeout(() => {
        lastExecuted.current = Date.now();
        setThrottledValue(value);
      }, interval);

      return () => clearTimeout(timerId);
    }
  }, [value, interval]);

  return throttledValue;
}

function useThrottle<T>(value: T, interval = 500): T {
  const [throttledValue, setThrottledValue] = useState<T>(value);
  const [timerId, setTimerId] = useState<number | null>(null);

  useEffect(() => {
    if (timerId) clearTimeout(timerId);

    const newTimerId = setTimeout(() => {
      setThrottledValue(value);
      setTimerId(null);
    }, interval) as unknown as number;

    setTimerId(newTimerId);

    // Очистка таймера при размонтировании компонента
    return () => {
      if (newTimerId) clearTimeout(newTimerId);
    };
  }, [value, interval]);

  return throttledValue;
}

export default useThrottle;
